/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Text, Icon } from '@components/atoms'
import { ListItem as MuiListItem, ListItemButton, ListItemProps } from '@mui/material'

type PropsType = ListItemProps & {
	title: string
	icon?: string
	iconStyle?: React.CSSProperties
	onClick?: () => void
}

export const ListItem = (props: PropsType) => {
	return (
		<MuiListItem css={style}>
			<ListItemButton className="button" onClick={props.onClick}>
				{props.icon !== undefined ? (
					<Icon
						name={props.icon}
						className="icon"
						css={[props.iconStyle !== undefined ? { ...props.iconStyle } : {}]}
					/>
				) : null}
				<Text
					category="p2"
					className={`${props.icon !== undefined ? 'indentedTitle' : ''}`}
				>
					{props.title}
				</Text>
			</ListItemButton>
		</MuiListItem>
	)
}

const style = css({
	position: 'relative',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-start',
	height: '2rem',
	minWidth: '6rem',
	padding: 0,

	'.button': {
		height: '100%',

		'.icon': {
			position: 'absolute',
			left: '0.5rem',
		},

		'.indentedTitle': {
			marginLeft: '1.5rem',
		},
	},
})
